document.addEventListener('DOMContentLoaded', function () {
  initCustomCart();
});

function initCustomCart() {
  document.querySelectorAll('[data-quantity-update]').forEach(button => {
    button.addEventListener('click', function () {
      const wrapper = this.closest('.quantity-selector');
      const input = wrapper.querySelector('[data-quantity-input]');
      let quantity = parseInt(input.value, 10);
      const direction = this.dataset.direction;

      quantity = direction === 'increase' ? quantity + 1 : Math.max(1, quantity - 1);
      input.value = quantity;
      input.dispatchEvent(new Event('change'));
    });
  });

  document.querySelectorAll('[data-quantity-input]').forEach(input => {
    input.addEventListener('change', function () {
      const quantity = Math.max(1, parseInt(this.value, 10));
      this.value = quantity;

      updateCartItem(this.closest('.custom-cart-item').dataset.cartItemKey, quantity);
    });
  });

  document.querySelectorAll('[data-cart-remove]').forEach(button => {
    button.addEventListener('click', function () {
      const itemKey = this.closest('.custom-cart-item').dataset.cartItemKey;
      updateCartItem(itemKey, 0);
    });
  });
}

function updateCartItem(itemKey, quantity) {
  const formData = new FormData();
  formData.append('id', itemKey);
  formData.append('quantity', quantity);

  fetch('/cart/change.js', {
    method: 'POST',
    body: formData
  })
    .then(res => res.json())
    .then(data => {
      if (quantity === 0) {
        document.querySelector(`.custom-cart-item[data-cart-item-key="${itemKey}"]`)?.remove();
      } else {
        const item = data.items.find(i => i.key === itemKey);
        if (item) {
          document.querySelector(`.custom-cart-item[data-cart-item-key="${itemKey}"] .custom-cart-item-price`).textContent = formatMoney(item.final_line_price);
        }
      }

      document.querySelector('.custom-cart-total-price').textContent = formatMoney(data.total_price);

      if (data.item_count === 0) {
        location.reload();
      }
    })
    .catch(err => console.error('Cart update error:', err));
}

function formatMoney(cents) {
  return `$${(cents / 100).toFixed(2)}`;
}
